export enum InjectableModelFactories {
    ICellModelFactory = "ICellModelFactory",
    EmptySquareModelFactory = "EmptySquareModelFactory",
    HalfSquareModelFactory = "HalfSquareModelFactory",
    FullSquareModelFactory = "FullSquareModelFactory",
    ITriangleModelFactory = "ITriangleModelFactory",
    IFigureModelFactory = "IFigureModelFactory"
}